import React from 'react';
import HiringQuery from 'apps/hiring/util/query';
import Confirm from 'library/helpers/confirm';
import { jsonToInputParams } from 'library/util/graph';

const REJECT = 'Rejected';
const HIRE = 'Hire';
const APPLIED = 'Applied';


const setStatus = async(id, newStatus, archive=false) => {
  if (newStatus === HIRE) return await hireApplicant(id);
  try {
    await HiringQuery(`
          mutation {
            update_application(id:${id}, status: "${newStatus}", archived: ${archive}) {
              errors,
              success
            }
          }
        `);
  } catch (e) {
    console.error(e);
  }
};

export const unHireEmployee = async (id) => {
  try {
    await HiringQuery(`
      mutation {
        unhire(id: ${id}) {
          errors,
          success
        }
      }
    `);
  } catch (e) {
    console.error(e);
  }
};

export const rejectApplicant = async (id) => (
  setStatus(id, REJECT)
);

export const appliedApplicant = async (id) => (
  setStatus(id, APPLIED)
);

export const archiveApplicant = async (id) => (
  setStatus(id, REJECT, true)
);

export const hireApplicant = async (id) => {
  try {
    await HiringQuery(`
      mutation {
        hire(id:${id}) {
          errors,
          success
        }
      }
        `);

  } catch (e) {
    console.error(e);
  }
};

const setToEmployeeList = async (user_id, opening_id) => {
  try {
    const params = {
      node_id: Number(opening_id),
      user_id: Number(user_id),
      user_type: 'Employee'
    };
    await HiringQuery(`
      mutation {
        create_node_policy (${jsonToInputParams(params)}) {
          success
          errors
        }
      }
    `);
  } catch (e) {
    console.error(e);
  }
};

export const hireApplicantWithModal = async (emp_id, opening_id, user_id) => {
  const message = (
    <p> This will HIRE the applicant and convert them to an employee </p>
  );
  if (await Confirm('Are you sure?', { children: message })) {
    try {
      await HiringQuery(`
        mutation {
          hire(id:${Number(emp_id)}) {
            errors,
            success
          }
        }
          `);
    } catch (e) {
      console.error(e);
    }

    if (opening_id !== null) {
      setToEmployeeList(user_id, opening_id);
    }
  }
};

export const rejectApplicantWithModal = async (id) => {
  const message = (
    <p> This will REJECT the applicant. You can still view this applicant in the opening dashboard.</p>
  );
  if (await Confirm('Are you sure?', {children: message })) {
    setStatus(id, REJECT);
  }
};

export const unHireEmployeeWithModal = async (id) => {
  const message = (
    <p> This action will un-hire this employee and return them to applicant status. </p>
  );
  if (await Confirm('Are you sure?', {children: message })) {
    await unHireEmployee(id);
  }
};

export const unRejectApplicantWithModal = async  (id) => {
  const message = (
    <p> This will reactivate the applicant.</p>
  );
  if (await Confirm('Are you sure?', {children: message })) {
    setStatus(id, APPLIED);
  }
};

export const archiveApplicantWithModal = async (id) => {
  const message = (
    <p> This will archive the applicant </p>
  );
  if (await Confirm('Are you sure?', {children: message })) {
    setStatus(id, REJECT, true);
  }
};

export const unarchiveApplicantWithModal = async (id) => {
  const message = (
    <p> This will unarchive the applicant </p>
  );
  if (await Confirm('Are you sure?', {children: message })) {
    setStatus(id, APPLIED, false);
  }
};

export const applicantActions = {
  ['Hire']:hireApplicantWithModal,
  ['Reject']:rejectApplicantWithModal,
  ['Unreject']:unRejectApplicantWithModal,
  ['Archive']:archiveApplicantWithModal,
  ['Unarchive']: unarchiveApplicantWithModal,
  ['Unhire']: unHireEmployeeWithModal
};
